module.exports = __webpack_public_path__ + "static/media/quote.6b4f7ba6.png";